<template>
<div style="width:200px; margin:auto;">
<img style="text-align:center;" src="../../assets/img/ray_small.png" />
<br />
  <button class="btn btn-process-order" v-on:click="addRayToOrder()">Confirm my Order</button>
</div>
</template>
<script>
import * as chargebeeCheckout from '../../helpers/chargebee-checkout';

export default {
  name: 'AddChargeToOrder',
  data(){
    return {
      subscriptionId: ''
    }
  },
  created(){
    this.subscriptionId = this.$route.query.orderid
  },
  methods: {
    addRayToOrder: async function (){
      await chargebeeCheckout.addRayToOrder(this.subscriptionId);
    }
  }
}
</script>
